<template>
  <div class="flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="60px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="9" :offset="0">
          <el-form-item prop="name" label="姓名">
            <el-input
              v-model="searchModel.name"
              placeholder="请输入"
              clearable
              @keyup.enter.native="getRoleUserList(true)"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="15" :offset="0">
          <el-button type="success" @click="getRoleUserList(true)">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <div class="table-main">
      <div class="table-header">
        <div class="header-button-lf">
          <el-button v-auth="'role:people'" type="primary" @click="handleAdd">新增</el-button>
          <el-button v-auth="'role:people'" type="warning" plain @click="handleRemove">批量解绑</el-button>
        </div>
      </div>
      <el-table
        ref="table"
        :data="tableData"
        border
        stripe
        v-loading="tableLoading"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="login_name" label="登录账号" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev,sizes, pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <RoleUserEdit :visible.sync="editVisible" :roleId="roleId" :roleName="roleName" @refresh="getRoleUserList()" />
  </div>
</template>

<script>
import RoleUserEdit from './RoleUserEdit';

import { getRoleUserList, deleteRoleUser } from '@/api/user';

export default {
  components: { RoleUserEdit },
  props: {
    roleId: {
      type: String,
      default: ''
    },
    roleName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        select: 1,
        name: ''
      },
      dataTotal: 0,
      tableData: [],
      tableLoading: false,
      tableSelection: [],
      removeLoading: false,
      editVisible: false
    };
  },
  computed: {},
  watch: {
    roleId(val) {
      if (val) this.getRoleUserList();
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.tableSelection = val;
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getRoleUserList(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getRoleUserList();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getRoleUserList(true);
    },
    async getRoleUserList(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;

      this.tableLoading = true;
      const { data } = await getRoleUserList({ ...this.searchModel, roleId: this.roleId });

      this.tableData = data.list || [];
      this.dataTotal = data.count || 0;
      this.tableLoading = false;
    },
    handleAdd() {
      this.editVisible = true;
    },
    handleRemove() {
      if (this.tableSelection.length == 0) return this.$message.warning('请选择要解绑的用户!');

      this.$confirm('确定解绑所选用户的角色权限吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const ids = this.tableSelection.map(item => item.id).join(',');
          const params = { roleId: this.roleId, ids };
          this.removeLoading = true;

          try {
            await deleteRoleUser(params);
            this.getRoleUserList(true);
            this.$message.success('解绑成功!');
          } finally {
            this.removeLoading = false;
          }
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped></style>
